export default {
  apiKey: 'AIzaSyAJD8N3BPF_rOlJW0HOjGOsCZtJGiqcMXI',
  authDomain: 'vidatec-engage4.firebaseapp.com',
  projectId: 'vidatec-engage4',
  storageBucket: 'vidatec-engage4.appspot.com',
  messagingSenderId: '76039750732',
  appId: '1:76039750732:web:4e36fdcd36b5d971f4e0e9',
  measurementId: 'G-97WG26X6X7',
};
